import { isEmpty } from "lodash";
import Supercluster from "supercluster";

import { CLUSTER_RADIUS } from "../constants/srpFullMap";

const deepEqual = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);

const formatListing = (point, handleMarkerClick) => {
  const {
    geometry: { coordinates },
    properties: { propertyId }
  } = point;
  const coords = { eastWestLng: coordinates[0], northSouthLat: coordinates[1] };

  return {
    key: `listing-${propertyId}`,
    markerId: propertyId,
    ...coords,
    onMarkerClick: () => handleMarkerClick([propertyId], coords),
    overText: "1",
    showDot: true
  };
};

const formatCluster = (cluster, point, handleMarkerClick) => {
  const {
    geometry: { coordinates },
    properties: { point_count }
  } = point;
  const key = `cluster-${point.id}`;
  const coords = { eastWestLng: coordinates[0], northSouthLat: coordinates[1] };
  const propertyIds = cluster
    .getLeaves(point.id, Infinity)
    .map(listing => listing.properties.propertyId);

  return {
    key,
    markerId: key,
    ...coords,
    onMarkerClick: () => handleMarkerClick(propertyIds, coords),
    overText: point_count.toString(),
    showDot: true
  };
};

const formatForMap = (cluster, clusterPoints, handleMarkerClick) =>
  clusterPoints.map(point =>
    point.type === "Listing"
      ? formatListing(point, handleMarkerClick)
      : formatCluster(cluster, point, handleMarkerClick)
  );

const formatForClusters = markerData => {
  if (isEmpty(markerData)) return [];

  const markers = JSON.parse(markerData);
  const keys = Object.keys(markers);
  return keys.map(key => ({
    type: "Listing",
    properties: { cluster: false, propertyId: key },
    geometry: {
      type: "Point",
      coordinates: markers[key]
    }
  }));
};

const generateCluster = (markerData, maxZoom, minZoom) => {
  const markers = formatForClusters(markerData);
  const cluster = new Supercluster({
    radius: CLUSTER_RADIUS,
    maxZoom,
    minZoom
  });
  cluster.load(markers);

  return cluster;
};

const generatePoints = (bounds, cluster, zoom) => {
  const { eastLng, northLat, southLat, westLng } = bounds;
  const bbox = [westLng, southLat, eastLng, northLat];
  return cluster.getClusters(bbox, zoom);
};

export { deepEqual, formatForMap, generateCluster, generatePoints };
